import { xlCol, xlColq } from '../../common/constants'

const od = (translations) => translations?.outDelivery || {}
const pick = (o, key, fallback) => o[key] || fallback

export const getActionList = (translations) => {
  const o = od(translations)
  return [
    { name: pick(o, 'assign', 'Assign'), id: 0 },
    { name: pick(o, 'change', 'Change'), id: 1 },
    { name: pick(o, 'cancel', 'Cancel'), id: 2 },
  ]
}

export const getTableHeaders = (translations) => {
  const o = od(translations)
  return [
    { headerName: pick(o, 'lrNumberOfflineLrNo', 'LR Number \nOffline LR No'), field: 'lrNumber', xlCol: xlCol },
    { headerName: pick(o, 'receiveDateChallanNo', 'Receive Date\nChallan No.'), field: 'receiveDate', xlCol: xlCol },
    { headerName: pick(o, 'sourceCitySourceBranch', 'Source City\nSource Branch'), field: 'sourceCityBranch', xlCol: xlCol },
    { headerName: pick(o, 'destinationCityDestinationBranch', 'Destination City\nDestination Branch'), field: 'destinationCityBranch', xlCol: xlCol },
    { headerName: pick(o, 'paymentTypeLrDueAmt', 'Payment Type\n LR Due Amt.'), field: 'paymentTypeAmt', xlCol: xlCol },
    { headerName: pick(o, 'totalNoOfUnitsPaymentMethod', 'Total No of Units \nPayment Method'), field: 'totalNoOfUnits', xlCol: xlCol },
    { headerName: pick(o, 'freightDeliveryCartage', 'Freight \nDelivery Cartage'), field: 'freight', xlCol: xlCol },
    { headerName: pick(o, 'receiverNameDeliveryHamali', 'Receiver Name\nDelivery Hamali'), field: 'receverName', xlCol: xlCol },
    { headerName: pick(o, 'receiverNumberDeliveryOpHamali', 'Receiver Number \nDelivery Op. Hamali'), field: 'receiverNumber', xlCol: xlCol },
    { headerName: pick(o, 'assignedByUserDemurrageChg', 'Assigned By User \nDemurrage Chg.'), field: 'assignedBy', xlCol: xlCol },
    { headerName: pick(o, 'assignedDateDeliveryDiscount', 'Assigned Date \nDelivery Discount'), field: 'assignedDate', xlCol: xlCol },
    { headerName: pick(o, 'ofdStatusDeliveryGst', 'OFD Status \n Delivery GST'), field: 'ofdStatus', xlCol: xlCol },
    { headerName: pick(o, 'totalOutstanding', 'Total Outstanding'), field: 'outDeliveryDate', xlCol: xlColq },
  ]
}

export const tableHeadersfilter = [
  { headerName: '', field: 'LRNO', xlCol: xlCol },
  { headerName: '', field: 'ManualLRNo', xlCol: xlColq },
  { headerName: '', field: 'ReceiptDate', xlCol: xlCol },
  { headerName: '', field: 'ChallanNo', xlCol: xlCol },
  { headerName: '', field: 'BookingCity', xlCol: xlCol },
  { headerName: '', field: 'BookingBranch', xlCol: xlColq },
  { headerName: '', field: 'BookingCity', xlCol: xlCol },
  { headerName: '', field: 'DestinationCity', xlCol: xlColq },
  { headerName: '', field: 'DestinationBranch', xlCol: xlCol },
  { headerName: '', field: 'DueAmount', xlCol: xlCol },
]

export const getTablePending = (translations) => {
  const o = od(translations)
  return [
    { headerName: pick(o, 'sn', 'SN'), field: 'SN', xlCol: xlCol, weight: 30, showfilter: false },
    { headerName: pick(o, 'lrNumber', 'LR Number'), field: 'LRNO', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'offlineLrNo', 'Offline LR No'), field: 'ManualLRNo', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'paymentType', 'Payment Type'), field: 'PaymentTypeName', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'sourceCity', 'Source City'), field: 'BookingCity', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'sourceBranch', 'Source Branch'), field: 'BookingBranch', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'destinationCity', 'Destination City'), field: 'DestinationCity', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'destinationBranch', 'Destination Branch'), field: 'DestinationBranch', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'receiveDate', 'Receive Date'), field: 'ReceiveDateTime', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'units', 'Units'), field: 'Units', xlCol: xlColq, weight: 30, showfilter: true },
    { headerName: pick(o, 'lrDueAmt', 'LR Due Amt.'), field: 'DueAMount', xlCol: xlColq, weight: 30, showfilter: true },
    { headerName: pick(o, 'receiverName', 'Receiver Name'), field: 'RecName', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'receiverNumber', 'Receiver Number'), field: 'RecMobileNo', xlCol: xlCol, weight: 30, showfilter: true },
  ]
}

export const getTableStatus = (translations) => {
  const o = od(translations)
  return [
    ...getTablePending(translations),
    { headerName: pick(o, 'assignedToUser', 'Assigned To User'), field: 'AssignedUser', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'assignedDate', 'Assigned Date'), field: 'DeliveryAssignedDate', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'assignedReturnedByUser', 'Assigned/Returned By User'), field: 'AssignedByUser', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'status', 'Status'), field: 'Status', xlCol: xlCol, weight: 30, showfilter: true },
    { headerName: pick(o, 'downloadPod', 'Download  POD'), field: 'PODLink', xlCol: xlCol, weight: 30, showfilter: false },
  ]
}

export const getExcelHeaderDataList = (translations) => {
  const o = od(translations)
  return [
    { header: pick(o, 'fromDate', 'From Date'), field: 'fromDate', xlCol: xlCol },
    { header: pick(o, 'toDate', 'To Date'), field: 'toDate', xlCol: xlCol },
    { header: pick(o, 'cityName', 'City Name'), field: 'CityName', xlCol: xlCol },
    { header: pick(o, 'branchName', 'Branch Name'), field: 'BranchName', xlCol: xlCol },
    { header: pick(o, 'userName', 'User Name'), field: 'UserName', xlCol: xlCol },
    { header: pick(o, 'status', 'Status'), field: 'Status', xlCol: xlCol },
  ]
}

export const getOutDeliveryFilterPlaceholders = (translations) => {
  const o = od(translations)
  return {
    lrNoDot: pick(o, 'lrNoDot', 'LR No.'),
    offlineLrNoDot: pick(o, 'offlineLrNoDot', 'Offline LR No.'),
    date: pick(o, 'date', 'Date'),
    challanNoDot: pick(o, 'challanNoDot', 'Challan No.'),
    city: pick(o, 'city', 'City'),
    branch: pick(o, 'branch', 'Branch'),
    paymentType: pick(o, 'paymentType', 'Payment Type'),
    dueAmount: pick(o, 'dueAmount', 'Due Amount'),
    noOfUnits: pick(o, 'noOfUnits', 'No. of Units'),
    freight: pick(o, 'freight', 'Freight'),
    receiverName: pick(o, 'receiverName', 'Receiver Name'),
    receiverNumber: pick(o, 'receiverNumber', 'Receiver Number'),
    assignedBy: pick(o, 'assignedBy', 'Assigned By'),
    assignedDate: pick(o, 'assignedDate', 'Assigned Date'),
    ofdStatus: pick(o, 'ofdStatus', 'OFD Status'),
    totalOutstanding: pick(o, 'totalOutstanding', 'Total Outstanding'),
    contains: pick(o, 'contains', 'Contains'),
    deliveryCartage: pick(o, 'deliveryCartage', 'Delivery Cartage'),
    deliveryHamali: pick(o, 'deliveryHamali', 'Delivery Hamali'),
    receiverMobileNo: pick(o, 'receiverMobileNo', 'Receiver Mobile No'),
    deliveryOpHamali: pick(o, 'deliveryOpHamali', 'Delivery Op. Hamali'),
    demurrageChr: pick(o, 'demurrageChr', 'Demurrage Chr'),
    discountDelivery: pick(o, 'discountDelivery', 'Discount Delivery'),
  }
}

export const translateOutDeliveryStatus = (status, translations) => {
  const o = od(translations)
  if (status === 'Out Delivered') return pick(o, 'statusOutDelivered', 'Out Delivered')
  if (status === 'Assigned') return pick(o, 'statusAssigned', 'Assigned')
  return status
}

export const getAllOptionLabel = (translations) => pick(od(translations), 'all', 'All')
